import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ConsultasComunes from '../Sql/ConsultasComunes';
import ConsultasReporte from '../Sql/ConsultasReporte';
import DateConverter from '../Tools/DateConverter';
function OrdenesProduccion() {
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [fechaIni, setFechaIni] = useState('');
    const [fechaFin,setFechaFin] = useState('');
    const [regional, setRegional] = useState('');
    const [ordenesProd, setOrdenesPro] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState('*');
    const obtenerSucursales = async (regional) => {
        try {
            var result = await ConsultasComunes.getSucursales(regional)
            if (result.ok) {
                console.log(result.ok);
                setSucursales(result.ok);
            } else {
                MsgUtils.msgError(result.error);
            }
        } catch (error) {
            MsgUtils.msgError(error)
        }
    }
    const buscarOrdenProduccion = async () => {
        if (idSucursal != 0 && fechaIni != '' && fechaFin != '') {
            try {
                var result = await ConsultasReporte.getOrdenProduccion({ idSucursal, fechaIni,fechaFin, regional })
                if (result.ok) {
                    console.log(result.ok)
                    setOrdenesPro(result.ok);
                } else {
                    MsgUtils.msgError(result.error);
                }
            } catch (error) {
                MsgUtils.msgError(error)
            }
        } else {
            MsgUtils.msgError("Complete la información")
        }
    }
    useEffect(() => {
        const infoUser = localStorage.getItem('info');
    
        console.log('info en localStorage:', infoUser);
    
        if (!infoUser) {
            console.log('❌ No existe info en localStorage');
            return;
        }
    
        try {
            const usuario = JSON.parse(infoUser);
    
            console.log('✅ info parseada:', usuario);
            console.log('ID_REGIONAL_ACTUAL:', usuario?.ID_REGIONAL_ACTUAL);
    
            if (sucursales.length === 0) {
    
                if (usuario?.ID_REGIONAL_ACTUAL) {
                    setRegional(usuario.ID_REGIONAL_ACTUAL);
                    obtenerSucursales(usuario.ID_REGIONAL_ACTUAL);
                } else {
                    console.log('❌ No existe ID_REGIONAL_ACTUAL');
                }
            }
    
        } catch (error) {
            console.error('❌ Error al convertir info:', error);
        }
    
    }, []);
    return (
        <>
            <div className='bg-dark bg-gradient container-fluid'>
                <div className='row row-cols py-1 g-1'>
                    <div className='col' style={{ maxWidth: '140px' }}>
                        <select className="form-select form-select-sm" aria-label="Default select example" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                            <option value={0} >NINGUNO</option>
                            {sucursales.map((item, index) => {
                                return (
                                    <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                )
                            })}
                        </select>
                        <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>Sucursal</div>
                    </div>
                    <div className='col' style={{ maxWidth: '140px' }}>
                        <input type='date' className='form-control form-control-sm' value={fechaIni}
                            onChange={(e) => setFechaIni(e.target.value)}></input>
                        <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>fecha Inicial</div>
                    </div>
                    <div className='col' style={{ maxWidth: '140px' }}>
                        <input type='date' className='form-control form-control-sm' value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}></input>
                        <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>fecha Final</div>
                    </div>
                    <div className='col' style={{ maxWidth: '140px' }}>
                        <select className="form-select form-select-sm" aria-label="Default select example"
                            value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                            <option value={'*'} >TODOS</option>
                            <option value={'N'} >NUEVOS</option>
                            <option value={'S'} >VALIDADOS O FINALIZADO</option>
                            <option value={'E'} >OP ELIMINADA</option>
                            <option value={'P'} >PENDIENTE</option>
                        </select>
                        <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>Estado</div>
                    </div>
                    <div className='col' style={{ maxWidth: '110px' }}>
                        <button className='btn btn-sm btn-success'
                            title='Mostrar ordenes de Producción'
                            onClick={() => buscarOrdenProduccion()}
                        ><i className="fa-solid fa-magnifying-glass fa-xl"></i> Buscar</button>
                        <div className='text-light text-center w-100' style={{ fontSize: '10px' }}></div>
                    </div>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-sm table-dark table-striped table-hover table-bordered border-secondary">
                    <thead>
                        <tr>
                            <th scope="col">Fecha</th>
                            <th scope="col">Validacion</th>
                            <th scope="col"># OP</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Estado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordenesProd.map((item, index) => {
                            if (filtroEstado == '*' || filtroEstado == item.ESTADO) {
                                return (
                                    <tr key={index}>
                                        <td className='lh-1'>
                                            <div>{DateConverter.formatoFecha(item.FECHA)}</div>
                                            <div>Hora: {DateConverter.formatoHoraSinSegu(item.FECHA)}</div>
                                        </td>
                                        <td className='lh-1'>
                                            <div>
                                                {item.FECHA_VALIDACION != null ? DateConverter.formatoFecha(item.FECHA_VALIDACION) : ''}
                                            </div>
                                            <div>
                                                Hora: {item.FECHA_VALIDACION != null ? DateConverter.formatoHoraSinSegu(item.FECHA_VALIDACION) : ''}
                                            </div>
                                        </td>
                                        <td>{item.ID_ORDEN_PRODUCCION}</td>
                                        <td>{item.NOMBRE}</td>
                                        <td>{item.NOMBRE_ESTADO}</td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default OrdenesProduccion